import React, { useEffect, useState, useRef } from 'react'
import qs from 'qs'
import { request } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'
import isIPad from 'meinian-package/src/common/isIPad'
import MNWaterfallApi from '../../../component/waterfall/masonryApi'
import Style from './recommendCard/style'
import Shop from './recommendCard/shop'
import Blogger from './recommendCard/blogger'
import HeaderTab from './headerTab'
import Header from './header'
import { TAB_ENUM, getCardTypeOption } from './common'
import WrapList from './wrapCardList'
import Alert from '../../components/pageAlert'
import OfficialInspirationList from './officialInspiration'
import styles from './index.module.less'

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [tabValue, setTabValue] = useState(null)
  const [params, setParams] = useState({
    cardType: null,
  })
  const cardTypeResult = useRef({
    option: []
  })
  const domRef = useRef()
  const Component = ListComponent?.[tabValue]

  useEffect(() => {
    if (query.tab) {
      setTabValue(+query.tab)
      cardTypeResult.current = getCardTypeOption(query.tab)
      setParams({
        cardType: cardTypeResult.current.defaultValue,
      })
    }
  }, [])

  const onTabChange = (val, curTabItem) => {
    setTabValue(val)
    cardTypeResult.current = getCardTypeOption(val || 1)
    setParams({
      cardType: cardTypeResult.current.defaultValue,
    })
    if (curTabItem) {
      util.track('mn-header-link', {
        module1: '侧边栏',
        module2: '智能选款',
        module3: curTabItem?.label,
      })
    }
  }
  const onCardTypeChange = (val) => {
    setParams({
      cardType: val,
    })
  }
  return <div className={styles.intellect}>
    <Header
      params={params}
      onCardTypeChange={onCardTypeChange}
      cardTypeResult={cardTypeResult}
      tabValue={tabValue}
      root={domRef.current}
      onChange={onTabChange}
    />
    <div className="intellect-header" ref={domRef}>
      <HeaderTab
        cardTypeResult={cardTypeResult}
        value={tabValue}
        params={params}
        onChange={onTabChange}
        onCardTypeChange={onCardTypeChange}
      />
    </div>
    {
      tabValue === TAB_ENUM.style && <div style={{ padding: '0px 20px 16px 20px' }}>
        <Alert
          message="采集越多，推荐越准哦，看见喜欢的图片就“采集”收藏进美念吧"
          keyValue="mn-collection-recommendation"
        />
      </div>
    }
    <div style={{ padding: '0px 24px 24px 24px' }}>
      {
        Component && <Component wrapParams={params} setParams={setParams} />
      }
      {
        tabValue === TAB_ENUM.inspiration && <OfficialInspirationList cardTypeResult={cardTypeResult} />
      }
    </div>
  </div>
}

const List = ({ wrapParams }) => { // 店铺
  const [data, setData] = useState([])
  const [resultCount, setResultCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [params] = useState({
    pageSize: 20,
    start: 0,
  })

  useEffect(() => {
    params.start = 0
    fetchData({ ...params, platformId: wrapParams.cardType })
  }, [wrapParams])

  const fetchData = async (_params) => {
    setLoading(true)
    const result = await request.get('/zhikuan/mn/recommend/shop-list', {
      params: _params,
    })
    setResultCount(result.resultCount)
    if (_params.start > 0) {
      setData([...data, ...result.resultList])
    } else {
      setData([...result.resultList])
    }
    setLoading(false)
  }

  const onUninterested = async (curData) => {
    const success = await request.post('/zhikuan/mn/recommend/save-user-uninterested-shop', {
      shopId: curData.shopId,
    })
    if (success) {
      setData(pre => pre.filter(m => m.shopId !== curData.shopId))
    }
  }

  return <WrapList
    data={data}
    pageSize={params.pageSize}
    pageStart={params.start}
    resultCount={resultCount}
    loading={loading}
    onInit={(_pageStart) => {
      params.start = _pageStart
      fetchData({ ...params, start: _pageStart })
    }}
    columnCount={isIPad ? 2 : 3}
    renderCard={(props) => <Shop {...props} onUninterested={onUninterested} />}
  />
}

const BloggerList = ({ wrapParams }) => { // 博主
  const [data, setData] = useState([])
  const [resultCount, setResultCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [params] = useState({
    pageSize: 20,
    start: 0,
    platformId: wrapParams.cardType,
  })

  useEffect(() => {
    params.start = 0
    fetchData({
      ...params,
      platformId: wrapParams.cardType
    })
  }, [wrapParams])

  const fetchData = async (_params) => {
    setLoading(true)
    const result = await request.post(`/zhikuan/mn/recommend/page-blogger?start=${_params.start}&pageSize=${_params.pageSize}`, { ..._params, platformId: wrapParams.cardType, })
    setResultCount(result.resultCount)
    if (_params.start > 0) {
      setData([...data, ...result.resultList])
    } else {
      setData([...result.resultList])
    }
    setLoading(false)
  }

  const onUninterested = async (curData) => {
    const success = await request.post('/zhikuan/mn/recommend/save-user-uninterested-blogger', {
      bloggerId: curData.bloggerId,
      sourceType: curData.sourceType
    })
    if (success) {
      setData(pre => pre.filter(m => m.bloggerId !== curData.bloggerId))
    }
  }

  return <WrapList
    data={data}
    pageSize={params.pageSize}
    pageStart={params.start}
    loading={loading}
    resultCount={resultCount}
    onInit={(_pageStart) => {
      params.start = _pageStart
      fetchData({ ...params, start: _pageStart })
    }}
    columnCount={isIPad ? 2 : 3}
    renderCard={(props) => <Blogger {...props} onUninterested={onUninterested} />}
  />
}

const StyleList = ({ wrapParams }) => { // 款式
  const listRef = useRef()
  const onUninterested = async (curData) => {
    await request.post('/zhikuan/mn/recommend/save-user-uninterested-image', {
      blogId: curData.imageGroupEntityId,
      platformId: curData.platformId
    })
    listRef.current?.layout()
  }
  return <MNWaterfallApi
    ref={listRef}
    renderItem={Style}
    gutter={16}
    cardProps={{ onUninterested }} // allStyleFlag 区别于灵感集的硬编码
    url="/zhikuan/mn/recommend/page-item"
    method="post"
    params={{
      platformId: wrapParams.cardType,
    }}
  />
}

const ListComponent = {
  [TAB_ENUM.shop]: List,
  [TAB_ENUM.blogger]: BloggerList,
  [TAB_ENUM.style]: StyleList,
}
